import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' }) <PropsType>`
    height: auto;
`;

export const AKBetsLogo = observer('AKBetsLogo', ({ className, onClick }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        fill='none'
        height='24'
        onClick={onClick}
        viewBox='0 0 96 24'
        width='96'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='m14.39 20.614-.792-2.624H7.941l-.815 2.624H2.712L8.5 3.386h4.542l5.786 17.228H14.39Zm-3.6-11.931L9.206 13.85h3.15l-1.566-5.168h.002ZM29.39 20.614l-3.322-5.94-2.122 3.06v2.88h-4.114V3.386h4.114v7.43l5.23-7.43h4.672l-5.1 7.406 5.614 9.823h-4.971l-.001-.001ZM49.574 11.82c1.5.05 3.042 1.132 3.042 3.933 0 2.802-1.822 4.86-4.864 4.86h-7.8V3.387h7.8c2.68 0 4.436 1.826 4.436 4.603 0 2.571-1.542 3.678-2.614 3.729v.103-.001Zm-5.506-1.414h2.55c.921 0 1.542-.642 1.542-1.62 0-.978-.621-1.57-1.478-1.57h-2.614v3.19Zm2.764 6.377c.985 0 1.564-.694 1.564-1.722 0-1.027-.621-1.594-1.52-1.594h-2.808v3.316h2.764ZM65.624 20.614H54.202V3.386h11.335v4.166h-7.22v2.546h6.642v3.779h-6.643v2.571h7.308v4.166ZM75.48 7.628v12.986h-4.135V7.628h-4.5V3.386h13.136v4.242h-4.5ZM93.158 8.015l-4.028.978c-.278-1.646-1.329-2.16-2.164-2.16-.9 0-1.52.54-1.52 1.388 0 .489.149.926.835 1.105l2.914.824c2.635.797 4.093 2.34 4.093 5.117 0 4.037-3.129 5.733-6.107 5.733-3.493 0-6.15-2.032-6.557-5.323l4.2-.951c.343 1.62 1.221 2.288 2.443 2.288.986 0 1.693-.488 1.693-1.388 0-.514-.193-.925-.985-1.158l-2.98-.849c-2.399-.667-3.942-2.133-3.942-4.987 0-3.626 2.55-5.632 5.915-5.632 3.364 0 5.678 1.8 6.192 5.015h-.002Z' fill='#E8530E'/>
    </SvgElement>
));
